import * as types from './types';

export default {
  [types.SET_DOMAIN_GROUPS](state, groups) {
    state.all = groups;
  },
  [types.SET_CURRENT_DOMAIN_GROUP](state, payload) {
    state.current = Object.assign(state.current, payload);
  },
  [types.SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/domain-groups/mutations.js